// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"20": "e65b58e906880db9","467": "aba2c31dc627966d","978": "d360b9e4d817ca5f","983": "8dd7c99cb4018dd0",}[chunkId] + ".css"
}